module.exports = __webpack_public_path__ + "img/selected1.a0a2b24d.png";